import Alpine from 'alpinejs';
import api, { requireAuth, saveAnalyze, STORAGE_PRODUCT, STORAGE_PROMPT } from './api.js';

function createInkoCreationPrompt() {
  return {
    loading: true,
    busy: false,
    error: null,
    products: [],
    productKey: '',
    prompt: '',

    async init() {
      if (!requireAuth()) return;
      this.prompt = sessionStorage.getItem(STORAGE_PROMPT) || '';
      this.productKey = sessionStorage.getItem(STORAGE_PRODUCT) || '';
      try {
        const meta = await api.meta();
        this.products = meta.products || [];
        if (!this.productKey && this.products[0]) {
          this.productKey = this.products[0].key;
        }
      } catch (e) {
        this.error = e.response?.data?.message || 'Gagal memuat produk.';
      } finally {
        this.loading = false;
      }
    },

    async analyze() {
      this.error = null;
      const text = this.prompt.trim();
      if (text.length < 5) {
        this.error = 'Prompt minimal 5 karakter.';
        return;
      }
      this.busy = true;
      sessionStorage.setItem(STORAGE_PROMPT, text);
      sessionStorage.setItem(STORAGE_PRODUCT, this.productKey);
      try {
        const result = await api.analyze(text, this.productKey || undefined);
        saveAnalyze(result);
        window.location.href = '/inko-creation/spec';
      } catch (e) {
        this.error = e.response?.data?.message || 'Analisis gagal.';
      } finally {
        this.busy = false;
      }
    },
  };
}

Alpine.data('inkoCreationPrompt', createInkoCreationPrompt);
